exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-image[data-v-1f52212e] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    border-radius: 4px;\n}\n.single-file-detail[data-v-1f52212e] {\n    height: 200px;\n}\n.aspect-ratio[data-v-1f52212e] {\n    position: relative;\n    width: 100%;\n    border-radius: 4px;\n    height: 0;\n    padding-top: 100%;\n}\n", ""]);

// exports
